import React from 'react';
import { GLOBAL, GlobalDispatcher } from '../../App';
import KTween from '../../core/KTween';
import { mergeClassNames } from '../../utils/mergeClassNames';
import { Link } from '../ui/Link';
import styles from './Navigation.module.scss';

interface NavigationProps
{
	content:any[]
}

export class Navigation extends React.Component<NavigationProps>
{

	state = {
		open: false
	}

	private _nav:HTMLElement;

	componentDidMount()
	{
		GlobalDispatcher.on('hash_change', this._hashChange);
		this._nav.addEventListener('mouseenter', this._navOver);
		this._nav.addEventListener('mouseleave', this._navOut);
	}

	componentWillUnmount()
	{
		GlobalDispatcher.off('hash_change', this._hashChange);
	}

	private _hashChange	= () =>
	{
		this._closeMenu();
	}

	private _openMenu = () =>
	{
		document.body.classList.toggle('menu-open', true);
		this.setState({
			open: true,
		})
	}

	private _closeMenu = () =>
	{
		this.setState({open: false});
		document.body.classList.toggle('menu-open', false);
	}
	
	private _navOver = () =>
	{
		let items = this._nav.querySelectorAll('.bullet');
		items.forEach((b, i) => {
			if(!b['pos']) b['pos'] = 0;
			b['hiding'] = false;
			KTween.remove(b);
			KTween.tween(b, {pos: 1, onUpdate: ()=>this._updateBullet(b)}, 'easeOutQuart', 0.3, Math.random() * 0.3);
		});
	}

	private _navOut = () =>
	{
		let items = this._nav.querySelectorAll('.bullet');
		items.forEach((b, i) => {
			if(!b['pos']) b['pos'] = 0;
			b['hiding'] = true;
			KTween.remove(b);
			KTween.tween(b, {pos: 0, onUpdate: ()=>this._updateBullet(b)}, 'easeOutQuart', 0.2, Math.random() * 0.1);
		});
	}

	private _updateBullet = (bullet) =>
	{
		let label = bullet.querySelector('.label');
		let span = label.querySelector('span');
		let highlight = label.querySelector('.highlight');
		if(span)
		{
			let b = span.getBoundingClientRect();
			let p = Number(bullet['pos']);
			label.style['width'] = (b.width + 20) * p + 'px';
			highlight.style['opacity'] = bullet['hiding']?0:1 - ((p * 2) - 1) ** 2;
		}
	}

	render()
	{
		return (
			<>
				<nav ref={r => this._nav = r} className={mergeClassNames(['navigation'], styles)}>
					{
						this.props.content?.filter((item)=>item['navigation'] !== false).map((item, i) => {
							let label = item['data']['content'];
							while(typeof(label) != 'string'){
								label = label[0]['content'] || '';
							}
							return (
								<Link key={i} arrow={false} decoration={false} className={mergeClassNames(['bullet', item['props']?.['className'], item['props']['data-anchor'] == GLOBAL.router.hash?'selected':null], styles)} href={GLOBAL.router.currentPath + '/#' + item['props']['data-anchor']}>
									<div className={mergeClassNames('label', styles)}>
										<div className={mergeClassNames('highlight', styles)}></div>
										<div className={mergeClassNames('highlight', styles)}></div><span>{label}</span>
									</div>
								</Link>
							);
						})
					}
				</nav>
				<menu className={mergeClassNames(['menu', this.state.open?'open':null], styles)}>
					<div className={mergeClassNames('menu-btn', styles)} onClick={this.state.open?this._closeMenu:this._openMenu}>{this.state.open?'Close':'Menu'}</div>
					<div className={mergeClassNames(['menu-container'], styles)}>
						<ul className={mergeClassNames(['links'], styles)}>
							{
								this.props.content?.filter((item)=>item['navigation'] !== false).map((item, i) => {
									let label = item['data']['content'];
									while(typeof(label) != 'string'){
										label = label[0]['content'] || '';
									}
								return (
										<li key={i} className={mergeClassNames(['bullet', item['props']?.['className']], styles)}><Link arrow={false} decoration={false} href={GLOBAL.router.currentPath + '/#' + item['props']['data-anchor']}>{label}</Link></li>
									);
								})
							}
						</ul>
					</div>
				</menu>
			</>
		)
	}
}